import React, { useContext } from 'react'
import CartItem from './CartItem';
import './graphCart.css';

import customerStatus from '../../Data/customerStatus';
import agentStatus from '../../Data/agentStatus';

import { Context } from '../../utils/context';

const GraphCart = () => {
  const {heading} = useContext(Context);

  const data = heading === 'Customers Analysis' ? customerStatus : agentStatus;

  return (
    <> 
      <div className="cart">
        <div className="cartHead">
          <h3>{heading === 'Customers Analysis' ? 'Total Customer' : 'Total Calls'}</h3>
          <p>289</p>
        </div>
        <div className="cartContent">
          {
            data.map((item) => (<CartItem key={item.id} item={item} />))
          }
        </div>
      </div>
    </>
  )
}

export default GraphCart